import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class CustomReserveForm {
  /**
   * 予約設定マスタ検索
   * @param {*} rsvSetId 予約設定のID
   * @returns {int} 同時予約可能数
   */
  searchReserveSetting = async (rsvSetId = null) => {
    const filter = { rsvSetId };
    const result = await requestManager.get(`${API_PATH}/inputUserInfo/r/reserve-setting`, filter);
    return result.data;
  };

  /**
   * 予約フォーム設定マスタ検索
   * @param {*} formSetId 予約フォーム設定のID
   * @returns {object} 予約フォーム設定
   */
  getFormSetting = async (lgCd, gettingGroupId, formSetId = null) => {
    let query = '';

    if (formSetId !== '') {
      query = { formSetId, lgCd };
    } else {
      query = { lgCd, gettingGroupId };
    }
    const result = await requestManager.get(`${API_PATH}/inputUserInfo/r/form`, query);
    return result.data;
  };

  /**
   * グループID検索
   * @param {*} rsvSetId 予約設定ID
   * @returns グループID
   */
  getGroupId = async (rsvSetId) => {
    const result = await requestManager.get(`${API_PATH}/inputUserInfo/r/group`, { rsvSetId });
    return result;
  };
}

export default new CustomReserveForm();
